import { BlockComponentFactory } from '../BlockFactory'
import { GridBlockProps } from './block-props.types'
import { useMemo } from 'react'

export const GridBlock = BlockComponentFactory.createBlockComponent<GridBlockProps>(props => {
    const {
        verticalAlignment = 'top',
        items = [],
        visibility = 'visible',
        children,
        gap = 8,
    } = props

    const safeItems = useMemo(() => {
        return items.map(item => ({
            ...item,
            span: item?.span ?? 1,
        }))
    }, [items])

    const childrenArray = Array.isArray(children) ? children : []

    const alignItems = useMemo(() => {
        switch (verticalAlignment) {
            case 'top':
                return 'start'
            case 'middle':
                return 'center'
            case 'bottom':
                return 'end'
            default:
                return 'start'
        }
    }, [verticalAlignment])

    const gridTemplateColumns = useMemo(() => {
        if (safeItems.length === 0) return 'none'
        return safeItems.map(item => `${item.span}fr`).join(' ')
    }, [safeItems])

    const gridStyle: React.CSSProperties = {
        ...props.style,
        display: visibility === 'hidden' ? 'none' : 'grid',
        gridTemplateColumns,
        alignItems,
        gap: '12px',
        width: '100%',
    }

    return (
        <div style={gridStyle}>
            {safeItems.map((column, index) => {
                const columnChildren = childrenArray[index] || null

                return (
                    <div
                        key={column.id}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: `${gap}px`,
                            minWidth: 0,
                            maxWidth: '100%',
                            width: '100%',
                            overflow: 'auto',
                        }}
                    >
                        {columnChildren}
                    </div>
                )
            })}
        </div>
    )
})
